import {Toolbar} from 'ngx-editor';

export const EDITOR_TOOLBAR: Toolbar = [
  ['bold', 'italic', 'underline'],
  ['bullet_list', 'ordered_list'],
  ['undo', 'redo'],
];
